export const createNoBackdropCloseHandler =
  (onClose) =>
  (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }

    onClose(event, reason);
  };
